/**
 * Utils method for lyra operations
 * 
 * Author: Sahil David
 */

/**
 * Function to remove HTML tags from string
 * @param value - {string} value to remove HTML tags
 * @returns - string value after removing all tags
 */
export function stripTags (value: string): string {
	return value.replace(/<[^>]*>?/gm, '');
}

/**
 * Function to wrap asset value in HTML tag
 * @param key {string} string key for asset value
 * @param value {string} value of the asset
 * @returns - string as html for the asset value
 */
export function assetHtml (key: string, value: string): string {
	const wrapper: HTMLElement = document.createElement('div');

	wrapper.classList.add('lyra-asset')
	wrapper.setAttribute('data-key', key);
	wrapper.innerHTML = value;

	return wrapper.outerHTML;
}

/**
 * Function to wrap citation value in HTML tag
 * @param key {string} string key for citation value
 * @param value {string} value of the citation
 * @returns - string as html for the citation value
 */
export function citationHtml (key: string, value: string): string {
	const wrapper: HTMLElement = document.createElement('div');

	wrapper.classList.add('lyra-citation')
	wrapper.setAttribute('data-key', key);
	wrapper.innerHTML = value;

	return wrapper.outerHTML;
}